<template>
  <div fluid>
    <!-- <div class="pt-1 d-flex">
        <v-text-field
          style="max-width: 250px"
          dense
          filled
          class="pl-0 mr-2"
          placeholder="search"
          solo
          flat
          color="cyan"
          :loading="pageLoading"
        />
      </div> -->
    <v-card
      flat
      class="custom-setting-height custom-grey-border remove-border-radius"
    >
      <v-card-title class="headline grey lighten-4">
        <v-row style="overflow: auto">
          <v-col md="12">
            <v-simple-table
              class="simple-table custom-table-height"
              fixed-header
              style="height: calc(91vh - 240px)"
            >
              <thead>
                <tr>
                  <th class="simple-table-th">Sno.</th>
                  <th class="simple-table-th">Supplier Invoice No.</th>
                  <th class="simple-table-th">Start Date</th>
                  <th class="simple-table-th">End Date</th>
                  <th class="simple-table-th">Action</th>
                  <th class="simple-table-th"></th>
                </tr>
              </thead>

              <tbody class="custom-border-bottom">
                <template v-if="scheduleArr?.length">
                  <tr
                    v-for="(row, index) in scheduleArr"
                    :key="index"
                    link
                    class="alternate-listing-row"
                  >
                    <td class="td">{{ index + 1 }}</td>
                    <td class="td" width="18%">
                      <div class="d-flex">
                        <v-text-field
                          dense
                          filled
                          class="pl-0"
                          placeholder="Supplier Invoice No."
                          v-model="row.barcode"
                          solo
                          flat
                          color="cyan"
                          :loading="pageLoading"
                        />
                        <v-icon
                          :loading="pageLoading"
                          color="red"
                          :disabled="!row.barcode ? true : false"
                          v-on:click="removeRow(index)"
                        >
                          mdi-delete</v-icon
                        >
                      </div>
                    </td>
                    <td class="td">
                      <DatePicker
                        clearable
                        :disabled="pageLoading"
                        key="charge-start-date"
                        id="charge-start-date"
                        placeholder="Start Date"
                        v-model="row.date"
                        v-on:clear="row.date = null"
                      />
                    </td>
                    <td class="td">
                      <div class="d-flex">
                        <DatePicker
                          clearable
                          :disabled="pageLoading"
                          key="charge-end-date"
                          id="charge-end-date"
                          placeholder="End Date"
                          :min-date="row.date"
                          v-model="row.end_date"
                          v-on:clear="row.end_date = null"
                        />
                      </div>
                    </td>
                    <td class="td">
                      <v-btn
                        :loading="pageLoading"
                        depressed
                        tile
                        color="cyan white--text"
                        v-on:click="saveInvoice(row)"
                      >
                        <v-icon size="15">mdi-pencil</v-icon> Update</v-btn
                      >
                    </td>
                    <td class="td">
                      <v-btn
                        :loading="pageLoading"
                        depressed
                        tile
                        color="cyan white--text"
                        v-on:click="createRentCharges"
                      >
                        <v-icon size="25">mdi-plus</v-icon></v-btn
                      >

                      <v-icon
                       :disabled="row?.id > 0  ? true : false"
                        size="25"
                        v-on:click="deleteRentCharges(index)"
                        color="red"
                        class="ml-2"
                        >mdi-delete</v-icon
                      >
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td :colspan="6" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no billing at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
  </div>
</template>
  
  <script>
import DatePicker from "@/view/components/main-job/QDatePicker.vue";
import { QUERY, PATCH } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import { BillingEventBus } from "@/core/lib/billing.invoice.lib.js";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  mixins: [CommonMixin],
  data() {
    return {
      pageLoading: false,
      scheduleArr: [
        {
          id: 0,
          barcode: null,
          date: null,
          end_date: null,
          type: "cross-rent",
        },
      ],
    };
  },
  props: {
    detail: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  methods: {
    createRentCharges() {
      this.scheduleArr.push({
        barcode: null,
        date: null,
        end_date: null,
        type: "cross-rent",
        id: 0,
      });
    },
    deleteRentCharges(index) {
      if (this.scheduleArr.length > 1) {
        this.scheduleArr.splice(index, 1);
      }
    },
    getBillings() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: "billing-schedule-list",
          data: {
            related_id: this.detail?.id,
            type: "cross-rent",
          },
        })
        .then(({ data }) => {
          if (data?.length > 0) {
            _this.scheduleArr = data;
          } else {
            _this.scheduleArr = [
              {
                id: 0,
                barcode: null,
                date: null,
                end_date: null,
                type: "cross-rent",
              },
            ];
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    removeRow(index) {
      this.scheduleArr[index].barcode = null;
    },
    saveInvoice(data) {
      this.pageLoading = true;

      this.$store
        .dispatch(PATCH, {
          url: "cross-rent-charge/" + this.detail?.id,
          data: {
            id: data?.id ?? 0,
            barcode: data.barcode ?? null,
            date: data.date ?? null,
            end_date: data.end_date ?? null,
            type: "cross-rent",
          },
        })
        .then(() => {
          this.getBillings();
        })
        .catch((error) => {
          this.logError(error);
          this.pageLoading = false;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.getBillings();

    BillingEventBus.$on("update:extend", () => {
      this.getBillings();
    });
  },

  components: {
    DatePicker,
  },
};
</script>
  <style>
.td {
  font-size: 14px !important;
  font-weight: 500;
}
</style>
  